import { useNavigate, useSearchParams } from "react-router";
import { QuickCaptureSheet } from "./QuickCaptureSheet";

/**
 * Landing route for the PWA share target (manifest share_target → GET
 * /capture?title=&text=&url=) and the "Capture" app shortcut. Opens the
 * quick-capture sheet prefilled with whatever was shared.
 */
export function CapturePage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const title = params.get("title") ?? undefined;
  const text = params.get("text") ?? "";
  const url = params.get("url") ?? "";
  // Android often puts the shared URL in `text`; when both exist, keep both.
  const initialText = [text, url].filter(Boolean).join("\n").trim();

  return (
    <div className="min-h-dvh bg-background">
      <QuickCaptureSheet
        open
        onClose={() => navigate("/", { replace: true })}
        initialText={initialText}
        initialTitle={title}
      />
    </div>
  );
}
